import MainSection from './mainSection/mainSection.component';
import { MainSectionSkeleton } from './mainSectionSkeleton/mainSectionSkeleton.component';
import EventInfoHeader from './eventInfoHeader/eventInfoHeader.component';

export { MainSection, MainSectionSkeleton,EventInfoHeader };
